export default __webpack_public_path__ + "static/parcheesi_case_webm-13f4e9c3ecd3bba63a4780ef89233280.webm";